export default __webpack_public_path__ + "locales/fr/ConvertDialog.json?hash=9b670839dd014ef36d689e021fd7ed68";